import { createAction } from '@reduxjs/toolkit'
import { StateKeysArrayType } from './types'

export const resetStore = createAction<StateKeysArrayType | undefined>('resetStore')
